import React from "react";

interface CType {
  statusList: any;
  profile: any;
  orgSettings?: any;
  loader: boolean;
  branchList: any;
  branch: any;
  roles: any;
  currentBilling: Record<string, any>;
  getBranches(): void;
  getRole(): void;
  getProfile(): void;
}

const SystemContext = React.createContext<CType>({
  loader: true,
  branchList: [],
  statusList: [],
  branch: [],
  orgSettings: {},
  currentBilling: {},
  roles: {},
  getBranches(): void {},
  profile: {},
  getRole(): void {},
  getProfile(): void {},
});
export const SystemProvider = SystemContext.Provider;
export default SystemContext;
